// extracted by mini-css-extract-plugin
module.exports = {"container":"ActivitiesEmptyState_container__1Nkap","link":"ActivitiesEmptyState_link__355ql"};